export default __webpack_public_path__ + "static/media/paymentRedirect.a44f8c1c.gif";